Vue.component('ack-home', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-home',
	mixins: [languageMixins],

	mounted() {
		appLog.log('ack-home mounted');

		this.getSlideList(this.mainSliderId).then(() => {
			this.sliders[this.mainSliderId] = this.slidersLists[this.mainSliderId];
		});
	},
	props: {
		// dataIn: {
		//   type: Object,
		//   required: true
		// }
	},
	computed: {
		...Vuex.mapGetters(['isMobile']),
		...Vuex.mapGetters('sliders', ['slidersLists']),
		...Vuex.mapGetters('articles', ['articlesArray']),
		lastArticles() {
			let arr = [];
			for (let index = 0; index < 3; index++) {
				const element = this.articlesArray[index];
				arr.push(element);
			}
			return arr;
		},
		mainSliderSlides() {
			return this.sliders[this.mainSliderId];
		},
		isMobile() {
			return this.$parent.isMobile;
		},
		testimonials() {
			return [
				{
					title: 'Efficient 3D Printing',
					rate: 5,
					content:
						'Implementing 3D printing into our restorative workflow was so easy with the Ackuretta SOL printer, CLEANI and CURIE. We are printing surgical guides, occlusal guards, crowns, models, all on x prototypes, provisionals and more.  I love its small footprint too.',
					authorImg:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/KOL_Testimonials_Susan_McMahon.jpg?v=1703825729',
					authorName: 'Dr. Susan McMahon',
				},
				{
					title: 'CURO ProSplint Soft',
					rate: 4,
					content:
						'I am able to perform the entire procedure using 3D printing with SOL and Curo ProSplint. The polishing process of the guard was excellent, leaving smooth surfaces that are comfortable for the patient and the occlusal tracks smooth to allow mandibular movements.',
					authorImg:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/KOL_Testimonials_Fermin_Ocanas.jpg?v=1704429036',
					authorName: 'Dr. Fermin Ocañas',
				},
				{
					title: 'SOL 3D Printer',
					rate: 5,
					content:
						'3D Printing with Ackuretta SOL is wonderful. It allows me to bring in a case that is normally outside of my wheel house and create a predictable and ultimately profitable workflow. And I had a patient leave with a great smile.',
					authorImg:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/KOL_Testimonials_Russell_Schafer.jpg?v=1703825731',
					authorName: 'Dr. Russell Schafer',
				},
			];
		},
		mainTitleData() {
			return {
				title1: 'New Generation Dental 3D Printing Solution',
				title2: null,
				subtitle1:
					'From design to post-processing, Ackuretta transforms same-day digital dentistry',
				subtitle2: 'with high-precision 3D Printing Solutions and validated workflows',
				buttonUrl: 'https://ackuretta.com/pages/get-a-quote',
				buttonText: 'Contact A Digital Dentistry Expert',
			};
		},
	},
	data() {
		return {
			pageId: 'home-page',
			mainSliderId: 'main-slider',
			sliders: {
				'main-slider': null,
			},
			carouselOptions: {
				arrows: false,
				dots: false,
				infinite: true,
				slidesToShow: 5,
				slidesToScroll: 1,
				autoplay: true,
				speed: 3000,
				autoplaySpeed: 0,
				cssEase: 'linear',
			},
			articles: null,
			banner_section: {
				title: 'Less Stress, More Success, We Got You Covered',
				url_image: 'https://ackuretta.com/pages/ackuretta-concierge',
				image:
					'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Concierge_Page_Home_page_banner.png?v=1725947661',
				imgAlt: 'Concierge_Page_Home_page_banner',
			},
			partnersLogos: [
				{
					name: '3Shape',
					logo: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Home_V4_3shape.png?v=1734514765',
				},
				{
					name: 'Exocad',
					logo: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Home_V4_Exocad.png?v=1699002751',
				},
				{
					name: 'Medit',
					logo: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Home_V4_Medit.png?v=1699002751',
				},
				{
					name: 'Argen',
					logo: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Home_V4_Argen.png?v=1699002752',
				},
				{
					name: 'BEGO',
					logo: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Home_V4_Bego.png?v=1699002751',
				},
				{
					name: 'Dentona',
					logo: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Home_V4_Dentona.png?v=1699002751',
				},
				{
					name: 'Keystone',
					logo: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Home_V4_Keystone.png?v=169900275',
				},
				{
					name: 'PacDent',
					logo: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Home_V4_Pac-dent.png?v=1699002752',
				},
				{
					name: 'Next Dent',
					logo: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Home_V4_Nextdent.png?v=1699002751',
				},
				{
					name: 'VOCO',
					logo: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/voco.png?v=1722327181',
				},
			],
		};
	},
	methods: {
		//...Vuex.mapActions(['sayHi', 'someAction']),
		...Vuex.mapActions('sliders', ['getSlideList']),
	},
	beforeDestroy() {},
	watch: {
		data1: {
			handler() {},
			deep: false,
		},
	},
});
